import React from 'react';

const Modal = ({ isOpen, onClose, children, maxWidth = "max-w-4xl" }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4">
        <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm" onClick={onClose} />
        <div className={`relative bg-white rounded-3xl shadow-2xl transform transition-all ${maxWidth} w-full my-8 overflow-hidden`}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
